module.exports = __webpack_public_path__ + "templates/about-policy.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/about/templates/about-policy.html
// module id = oIXu
// module chunks = 1